// 权限常量的定义
export default {
  // 分享
  XTDESIGN_DOWN: ":XtDesign:down",
  MYDOC_DOWN: ":mydoc:down",
  MYCOLLECTION_DOWN: ":mycollection:down",
  SHARINFORMATION_DOWN: ":sharinformation:down",
  PUBLICINFORMATION_DOWN: ":publicinformation:down",
  // 公告
  PRJNOTICE_DISABLE: ":prjNotice:disable",
  PRJNOTICE_EDIT: ":prjNotice:edit",
  PRJNOTICE_DEL: ":prjNotice:del",
  PRJNOTICE_ENABLE: ":prjNotice:enable",
  SYSNOTICE_DISABLE: ":sysNotice:disable",
  SYSNOTICE_EDIT: ":sysNotice:edit",
  SYSNOTICE_DEL: ":sysNotice:del",
  SYSNOTICE_ENABLE: ":sysNotice:enable",

  MYRECYCLE_DALE: "myrecycle:dele",
  MYRECYCLE_RECOVERY: "myrecycle:recovery",
  ENTPRECYCLE_DALE: "entprecycle:dele",
  ENTPRECYCLE_RECOVERY: "entprecycle:recovery",

  ENTERPRISEDEPTDOCRECYCLE_DEL: "enterpriseDeptDocRecycle:del",
  ENTERPRISEDEPTDOCRECYCLE_COVERY: "enterpriseDeptDocRecycle:covery",

  CREATEPROJECT_ADD: ":createProject:add",
  CREATEPROJECT_EDIT: "createProject:edit",
  CREATEPROJECT_SEE: ":createProject:see",
  CREATEPROJECT_DALE: ":createProject:dele",
  CREATEPROJECT_QUERY: ":createProject:query",
  CREATEPROJECT_RESET: ":createProject:reset",
  CREATEPROJECT_DOWN: "createProject:down",
  CREATEPROJECT_EDITALL: "createProject:editAll",
  CREATEPROJECT_SEEALL: "createProject:seeAll",
  CREATEPROJECT_DELEALL: "createProject:deleAll",

  // 族
  ZUNEWFOLDER: "zuNewFolder",
  ZURENAME: "zuRename",
  ZUDELETE: "zuDelete",
  ZUUPLOAD: "zuUpload",
  ZUEDITFAMILY: "editFamily",
  FAMILYDELETE: "familyDelete",

  CONFIGURATIONFILE_UPLOAD: ":configurationFile:upload",

  FRAMEFIELD_ADD: "frameField:add",
  FRAMEFIELD_EDIT: "frameField:edit",
  FRAMEFIELD_DALE: "frameField:dele",

  LINEARSTYLE_REFRESH: ":linearStyle:refresh",
  LINEARSTYLE_DALE: ":linearStyle:dele",
  LINEARSTYLE_ADD: ":linearStyle:add",
  LINEARSTYLE_EDIT: ":linearStyle:edit",

  PARAMETERFILE_UPLOAD: ":parameterFile:upload",

  PROVIDEINFORMATIONFRAME_REFRESH: ":provideInformationFrame:refresh",
  PROVIDEINFORMATIONFRAME_DALE: ":provideInformationFrame:dele",
  PROVIDEINFORMATIONFRAME_RENAME: ":provideInformationFrame:rename",
  PROVIDEINFORMATIONFRAME_UPLOAD: ":provideInformationFrame:upload",
  PROVIDEINFORMATIONFRAME_DOWN: ":provideInformationFrame:down",
  PROVIDEINFORMATIONFRAME_EDIT: ":provideInformationFrame:edit",

  PROVIDEINFORMATIONLAYER_EXPORT: ":provideInformationLayer:export",
  PROVIDEINFORMATIONLAYER_DALE: ":provideInformationLayer:dele",

  REVITMAINTENANCE_REFRESH: ":revitMaintenance:refresh",
  REVITMAINTENANCE_DALE: ":revitMaintenance:dele",
  REVITMAINTENANCE_UPLOAD: ":revitMaintenance:upload",
  REVITMAINTENANCE_DOWN: ":revitMaintenance:down",
  REVITMAINTENANCE_EDIT: ":revitMaintenance:edit",

  SIGNATURE_UPLOAD: ":signature:upload",
  SIGNATURE_BATCHUPLOAD: ":signature:batchupload",
  SIGNATURE_DOWN: ":signature:down",
  SIGNATURE_EDIT: ":signature:edit",
  SIGNATURE_DALE: ":signature:dele",

  STAMP_ADDCLASSIFICATION: ":stamp:addClassification",
  STAMP_ADDSUBCLASSIFICATION: ":stamp:addSubClassification",
  STAMP_EDITCLASSIFICATION: ":stamp:editClassification",
  STAMP_DELECLASSIFICATION: ":stamp:deleClassification",
  STAMP_UPLOAD: ":stamp:upload",
  STAMP_DOWN: ":stamp:down",
  STAMP_DALE: ":stamp:dele",

  STANDARDDRAWINGFRAME_REFRESH: ":standardDrawingFrame:refresh",
  STANDARDDRAWINGFRAME_DALE: ":standardDrawingFrame:dele",
  STANDARDDRAWINGFRAME_RENAME: ":standardDrawingFrame:rename",
  STANDARDDRAWINGFRAME_UPLOAD: ":standardDrawingFrame:upload",
  STANDARDDRAWINGFRAME_DOWN: ":standardDrawingFrame:down",
  STANDARDDRAWINGFRAME_EDIT: ":standardDrawingFrame:edit",

  STANDARDFONT_REFRESH: ":standardFont:refresh",
  STANDARDFONT_DALE: ":standardFont:dele",
  STANDARDFONT_RENAME: ":standardFont:rename",
  STANDARDFONT_UPLOAD: ":standardFont:upload",
  STANDARDFONT_DOWN: ":standardFont:down",
  STANDARDFONT_EDIT: ":standardFont:edit",

  STANDARDCADFONT_DALE: ":standardCadFont:dele",
  STANDARDCADFONT_RENAME: ":standardCadFont:rename",
  STANDARDCADFONT_UPLOAD: ":standardCadFont:upload",
  STANDARDCADFONT_DOWN: ":standardCadFont:down",
  STANDARDCADFONT_EDIT: ":standardCadFont:edit",

  STANDARLAYER_ADD: ":standardLayer:add",
  STANDARLAYER_DALE: ":standardLayer:dele",
  STANDARLAYER_EDIT: ":standardLayer:edit",

  STANDARDTEMPLATE_DALE: ":standardTemplate:dele",
  STANDARDTEMPLAT_UPLOAD: ":standardTemplate:upload",
  STANDARDTEMPLAT_DOWN: ":standardTemplate:down",
  STANDARDTEMPLAT_RENAME: ":standardTemplate:rename",
  STANDARDTEMPLAT_EDIT: ":standardTemplate:edit",

  STYLESHEET_UPLOAD: ":styleSheet:upload",

  TEMPLATA_ADD_TEMPLATE: ":template:addTemplate",
  TEMPLATA_RENAME_TEMPLATE: ":template:renameTemplate",
  TEMPLATA_DALE_TEMPLATE: ":template:deleTemplate",
  TEMPLATA_COPY_TEMPLATE: ":template:copyTemplate",
  TEMPLATA_PASTE_TEMPLATE: ":template:pasteTemplate",
  TEMPLATA_PEERADD_FLODER: ":template:peeraddFloder",
  TEMPLATA_DOWNADD_FLODER: ":template:downaddFloder",
  TEMPLATA_DELE_FLODER: ":template:deleFloder",
  TEMPLATA_EDIT_FLODER: ":template:editFloder",
  TEMPLATA_MOVEUP_FLODER: ":template:moveUpFloder",
  TEMPLATA_MOVEDOWN_FLODER: ":template:moveDownFloder",

  MYDOC_ADD: ":mydoc:add",
  MYDOC_MOVE: ":mydoc:move",
  MYDOC_COPY: ":mydoc:copy",
  MYDOC_SHARE: ":mydoc:share",
  MYDOC_DELE: ":mydoc:dele",
  MYDOC_UPLOAD: ":mydoc:upload",
  MYDOC_ENDEDIT: ":mydoc:endEdit",
  MYDOC_CANCELEDIT: ":mydoc:cancelEdit",

  MYCOLLECTION_SHARE: ":mycollection:share",

  PUBLICINFORMATION_DELE: ":publicinformation:dele",
  PUBLICINFORMATION_ADD: ":publicinformation:add",
  PUBLICINFORMATION_MOVE: ":publicinformation:move",
  PUBLICINFORMATION_COPY: ":publicinformation:copy",
  PUBLICINFORMATION_SHARE: ":publicinformation:share",
  PUBLICINFORMATION_UPLOAD: ":publicinformation:upload",

  SHARINFORMATION_DELE: ":sharinformation:dele",

  SHARINFORMATION_ADD: ":sharinformation:add",
  SHARINFORMATION_MOVE: ":sharinformation:move",
  SHARINFORMATION_COPY: ":sharinformation:copy",
  SHARINFORMATION_SHARE: ":sharinformation:share",
  SHARINFORMATION_UPLOAD: ":sharinformation:upload",

  MAINMGNEWS_DELE: ":mainMgNews:dele",

  SHILDPERSONPLAN: "childPersonPlan",
  SHILDPERSONPLAN_ADD: ":childPersonPlan:add",
  SHILDPERSONPLAN_DELE: ":childPersonPlan:dele",

  XTDESIGN_ADD: ":XtDesign:add",
  XTDESIGN_UPLOAD: ":XtDesign:upload",
  XTDESIGN_SHARE: ":XtDesign:share",
  XTDESIGN_DELE: ":XtDesign:dele",
  XTDESIGN_ATTRIBUTE: "XtDesign:attribute",
  XTDESIGN_HISTORY: ":XtDesign:history",

  XTDESIGN_DELECOMPLETELY: ":XtDesign:deleCompletely",

  ISSUEMG_ISSUE: ":issueMg:issue",
  ISSUEMG_PEOPLE: ":issueMg:people",
  ISSUEMG_EXPORT: ":issueMg:export",

  PERSONPLAN_ADD: ":personPlan:add",
  PERSONPLAN_DELE: ":personPlan:dele",
  PERSONPLAN_INVITATION: ":personPlan:invitation",

  SETUP_RELEASEPLANN: ":setup:releasePlann",
  SETUP_ADD_TEMPLATE: ":setup:addTemplate",
  SETUP_DELE_TEMPLATE: ":setup:deleTemplate",
  SETUP_ADD_FRAME: ":setup:addFrame",
  SETUP_DELE_FRAME: ":setup:deleFrame",
  SETUP_DOWN_FRAMEE: ":setup:downFrame",

  PRJNOTICE_STATE: ":prjNotice:state",
  PRJNOTICE_ADD: ":prjNotice:add",

  PROGRESSLIST_ADD: ":progressList:add",
  PROGRESSLIST_EXPORT: ":progressList:export",
  PROGRESSLIST_IMPORT: ":progressList:import",
  PROGRESSLIST_EDIT: ":progressList:edit",
  PROGRESSLIST_DEL: ":progressList:del",

  PERSONINFO_INVITATION: ":personInfo:invitation",
  PERSONINFO_MOREMEMBER: ":personInfo:moreMember",
  PERSONINFO_DELEBATCH: ":personInfo:deleBatch",
  PERSONINFO_EXPORT: ":personInfo:export",
  PERSONINFO_SEE: ":personInfo:see",
  PERSONINFO_EDIT: ":personInfo:edit",
  PERSONINFO_DELE: ":personInfo:dele",
  PERSONINFO_ADDPERSON: ":personInfo:addPerson",
  PERSONINFO_RESETPASS: ":personInfo:resetPass",
  PERSONINFO_ADD: ":personInfo:add",
  PERSONINFO_ENABLE: ":personInfo:enable",
  PERSONINFO_PWD_RESET: ":personInfo:pwd:reset",
  PERSONINFO_EXPORT_BATCH: ":personInfo:exportBatch",

  PROCESSDEFINITION_ADD_GROUP: ":processDefinition:addGroup",
  PROCESSDEFINITION_DELE_GROUP: ":processDefinition:deleGroup",
  PROCESSDEFINITION_EDIT_GROUP: ":processDefinition:editGroup",

  PROCESSDEFINITION_ADD: ":processDefinition:add",
  PROCESSDEFINITION_EDIT: ":processDefinition:edit",
  PROCESSDEFINITION_DALE: ":processDefinition:dele",

  ORGFRAMEWORKCONFIG_ADD: ":orgFrameworkConfig:add",
  ORGFRAMEWORKCONFIG_EDIT: ":orgFrameworkConfig:edit",
  ORGFRAMEWORKCONFIG_DALE: ":orgFrameworkConfig:dele",
  ORGFRAMEWORKCONFIG_ADDPEOPLE: ":orgFrameworkConfig:addPeople",
  ORGFRAMEWORKCONFIG_DELEPEOPLE: ":orgFrameworkConfig:delePeople",
  PERSONINFO_PWD_RESETPASSWORD: ":personInfo:pwd:resetPassWord",
  ORGFRAMEWORKCONFIG_MOVE: ":orgFrameworkConfig:move",
  ORGFRAMEWORKCONFIG_SETSUPER: ":orgFrameworkConfig:setSuper",

  ROLEPOWERCONFIG_ADDSYS_ROLE: ":rolePowerConfig:addSysRole",
  ROLEPOWERCONFIG_EDIT_ROLE: ":rolePowerConfig:editRole",
  ROLEPOWERCONFIG_DELE_ROLE: ":rolePowerConfig:deleRole",
  ROLEPOWERCONFIG_ADD_SPEC: ":rolePowerConfig:addSpec",
  ROLEPOWERCONFIG_EDIT_SPEC: ":rolePowerConfig:editSpec",
  ROLEPOWERCONFIG_DELE_SPEC: ":rolePowerConfig:deleSpec",
  ROLEPOWERCONFIG_ADD_ROLEUSER: ":rolePowerConfig:addRoleUser",
  ROLEPOWERCONFIG_DELE_ROLEUSER: ":rolePowerConfig:deleRoleUser",
  ROLEPOWERCONFIG_ADD_PRJROLE: ":rolePowerConfig:addPrjRole",

  SYSNOTICE_ADD: ":sysNotice:add",

  SYSTEMSET_ADD: ":systemSet:add",
  SYSTEMSET_EDIT: ":systemSet:edit",
  SYSTEMSET_DALE: ":systemSet:dele",
  SYSTEMSET_DELEBATCH: ":systemSet:deleBatch",

  LAYERDETACHFILE_ADDRULE: "layerDetachFile:addRule",
  LAYERDETACHFILE_EDITRULE: "layerDetachFile:editRule",
  LAYERDETACHFILE_DELRULE: "layerDetachFile:delRule",
  LAYERDETACHFILE_ADDLAYER: "layerDetachFile:addLayer",
  LAYERDETACHFILE_DELLAYER: "layerDetachFile:delLayer",

  ISOMANAGEMENT_BATCHDOWNLOAD: ":isoManagement:batchDownload",

  DOC_ADD: ":doc:add",
  DOC_DELETE: ":doc:delete",
  DOC_UPDATE: ":doc:update",

  ALLENTERPRISEDEPTDOC_ADD: ":allEnterpriseDeptDoc:add",
  ALLENTERPRISEDEPTDOC_UPLOAD: ":allEnterpriseDeptDoc:upload",
  ALLENTERPRISEDEPTDOC_MOVE: ":allEnterpriseDeptDoc:move",
  ALLENTERPRISEDEPTDOC_COPY: ":allEnterpriseDeptDoc:copy",
  ALLENTERPRISEDEPTDOC_DOWNLOAD: ":allEnterpriseDeptDoc:down",
  ALLENTERPRISEDEPTDOC_SHARE: ":allEnterpriseDeptDoc:share",
  ALLENTERPRISEDEPTDOC_DELETE: ":allEnterpriseDeptDoc:delete",

  AFFILIATIONENTERPRISEDEPTDOC_ADD: ":affiliationEnterpriseDeptDoc:add",
  AFFILIATIONENTERPRISEDEPTDOC_UPLOAD: ":affiliationEnterpriseDeptDoc:upload",
  AFFILIATIONENTERPRISEDEPTDOC_MOVE: ":affiliationEnterpriseDeptDoc:move",
  AFFILIATIONENTERPRISEDEPTDOC_COPY: ":affiliationEnterpriseDeptDoc:copy",
  AFFILIATIONENTERPRISEDEPTDOC_DOWNLOAD: ":affiliationEnterpriseDeptDoc:down",
  AFFILIATIONENTERPRISEDEPTDOC_SHARE: ":affiliationEnterpriseDeptDoc:share",
  AFFILIATIONENTERPRISEDEPTDOC_DELETE: ":affiliationEnterpriseDeptDoc:delete",

  // 视图管理
  VIEWNEWFOLDER: "viewNewFolder",
  VIEWRENAME: "viewRename",
  VIEWDELETE: "viewDelete",
  EDITVIEW: "editView",
  DELETEVIEW: "deleteView",

  // 流程干预权限
  FLOW_INSTANCE_PERMISSION: ":processInstance:intervene"
};
